// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-tags-input {\n  max-width: 100% !important;\n}\n.zfix {\n  z-index: 900;\n}\n.tag-suggestion {\n  height: -webkit-min-content;\n  height: -moz-min-content;\n  height: min-content;\n}\n[dir] .tag-suggestion .ti-tag, [dir] .tag-suggestion .ti-selected-item {\n  background-color: #156440;\n}\n[dir] .ti-input-border-primary .ti-input {\n  border-color: #156440;\n}", ""]);
// Exports
module.exports = exports;
